<script setup lang="ts">

import { useRouter } from "vue-router";
import debug from "debug";

const logger = debug("Container");

const props = defineProps<{
	title?: string;
	path?: string[];
	classes?: string[];
}>();

const router = useRouter();

const defaultRouteName = "home";
const breadcrumbs: { path: string, name: string, title: string }[] = [];
const matches = [router.getRoutes().find(r => r.name === defaultRouteName)!];

if (router.currentRoute.value.name !== defaultRouteName)
	matches.push(...router.currentRoute.value.matched);

let lastName = "";
let lastTitle = "";

for (const route of matches) {
	if (route.name) {
		if (route.name === lastName)
			continue;

		const title = (route.meta!.breadcrumb ? route.meta!.breadcrumb : route.meta!.title) as string;

		breadcrumbs.push({
			path: route.path,
			name: route.name as string,
			title: title
		});
		lastName = route.name as string;
		lastTitle = title;
	}
}


logger(router.currentRoute.value.matched);

</script>

<template>
	<div class="container mt-5 px-4" :class="classes ?? []">
		<nav v-if="breadcrumbs.length > 1" class="breadcrumb">
			<ul>
				<li v-for="route in breadcrumbs">
					<router-link :to="route.path">
						{{ route.title }}
					</router-link>
				</li>
			</ul>
		</nav>
		<div class="columns">
			<div class="column">
				<h1 class="title is-2">{{ lastTitle }}</h1>
			</div>
		</div>
		<slot />
	</div>
</template>

<style scoped>

</style>
